// NOTE: Port should match port being used for websocket in server, when running locally
//const endpoint = `//localhost:3001`;
const endpoint = '//switchbox-pointer.azurewebsites.net';

export { endpoint };
